/**
 * Bot Success Metrics (abbreviation):- BSM
 */
export const BSM_UPDATE_STATE = "BSM_UPDATE_STATE"